<template>
	<v-container>
		<v-app-bar app color="blue">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline">Emendas Estaduais </span>
				<!-- <span class="d-none d-sm-inline" v-else>Nova </span> -->
			</v-toolbar-title>

			<template v-slot:extension>
				<v-tabs v-model="tab" centered dark icons-and-text>
					<v-tabs-slider></v-tabs-slider>

					<v-tab href="#tab1">
						Geral
						<v-icon>mdi-cash-lock</v-icon>
					</v-tab>

					<v-tab href="#tab2">
						Saúde
						<v-icon>mdi-cash-multiple</v-icon>
					</v-tab>

					<v-tab href="#tab3" style="line-height: 1">
						<span>Especial</span>
						<span>Transferência</span>
						<v-icon>mdi-cash</v-icon>
					</v-tab>
				</v-tabs>
			</template>
		</v-app-bar>

		<v-tabs-items v-model="tab">
			<v-tab-item value="tab1">
				<iframe
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/1e40969f-93bb-482f-a2d3-2185431f817d"
					frameborder="0"
					width="1150"
					height="600"
					allowtransparency
				></iframe>
			</v-tab-item>

			<v-tab-item value="tab2">
				<iframe
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/9addf7ad-a393-42fc-98d7-75e65477924b"
					frameborder="0"
					width="1150"
					height="600"
					allowtransparency
				></iframe>
			</v-tab-item>

			<v-tab-item value="tab3">
				<iframe
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/feaa1ab8-a82d-4926-be12-5a81c791114c"
					frameborder="0"
					width="1150"
					height="600"
					allowtransparency
				></iframe>
			</v-tab-item>
		</v-tabs-items>
	</v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
//import VPageHeader from '@/components/PageHeader.vue';

export default {
	name: 'Home',
	data() {
		return {
			tab: 'tabGeral',
		};
	},

	async created() {
		this.$root.colorHeader = 'blue';
		this.$root.titleHeader = 'Painéis do Metabase';

		this.anoExercicio = this.$root.anoSelecionado;
	},

	watch: {
		'$root.anoSelecionado'() {
			this.anoExercicio = this.$root.anoSelecionado;
			this.fetchEmendas();
		},
	},
};
</script>

<style scoped>
.head-tile {
	margin: -10px -10px 0 -10px;
}
.row-pointer >>> tbody tr :hover {
	cursor: pointer;
}
</style>
